export default __webpack_public_path__ + "static/media/assign-client-active.6a324518.svg";